import React, { useRef, useState } from "react";
import { Card, Radio } from "antd";
import { OrderCsvUploadV1, OrderCsvUploadV1Prop } from "./OrderCsvUploadV1";
import { OrderCsvUploadV2 } from "./OrderCsvUploadV2";
import { useParams } from "react-router";
import { RadioWrapper } from "./styles";

const options = [
  { label: "V1", value: 1 },
  { label: "V2", value: 2 },
];

const versionToComponentMap = {
  1: OrderCsvUploadV1,
  2: OrderCsvUploadV2,
} as Record<number, React.FC<OrderCsvUploadV1Prop>>;

export const FulfillmentOrderCreateViaCsvPage: React.FC = () => {
  const [version, setVersion] = useState(2);
  const pageRef = useRef<HTMLDivElement>(null);
  const { organization_id: organizationId } = useParams<{ organization_id: string }>();
  const renderVersionToggle = () => {
    return (
      <RadioWrapper ref={pageRef}>
        <Radio.Group
          options={options}
          onChange={(e) => setVersion(e.target.value)}
          value={version}
          optionType="button"
        />
      </RadioWrapper>
    );
  };

  const renderUploadComponent = () => {
    const OrderCsvUploadComponent = versionToComponentMap[version];
    return <OrderCsvUploadComponent pageRef={pageRef} organizationId={organizationId} />;
  };

  return (
    <Card>
      {renderVersionToggle()}
      {renderUploadComponent()}
    </Card>
  );
};
